import { AccredibleUserApiService } from '@accredible-frontend-v2/services/user';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const lerTermsGuard: CanActivateFn = () => {
  const userApi = inject(AccredibleUserApiService);
  const router = inject(Router);

  const user = userApi.getUser();

  if (user?.ler_profile && !user.ler_profile.ler_terms_accepted) {
    return router.createUrlTree(['/accept-terms']);
  }

  return true;
};
